export function asMinutes(time) {
  return time / 1000 / 60;
}

export function differenceInMinutes(dateA, dateB) {
  return asMinutes(dateA - dateB);
}

export function getCorrectedTime(date, serverTimeDifference) {
  var corrected = new Date(date);
  corrected.setMilliseconds(corrected.getMilliseconds() - serverTimeDifference);
  return corrected;
}

export function endOfToday() {
  // calculate 4am local time on the following day
  var cutoff = new Date();
  cutoff.setDate(cutoff.getDate() + 1);
  cutoff.setHours(4, 0, 0, 0);
  return cutoff;
}
